import { render, staticRenderFns } from "./Mechanism.vue?vue&type=template&id=ce589992&scoped=true"
import script from "./Mechanism.vue?vue&type=script&lang=ts"
export * from "./Mechanism.vue?vue&type=script&lang=ts"
import style0 from "./Mechanism.vue?vue&type=style&index=0&id=ce589992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce589992",
  null
  
)

export default component.exports